import { estimateConstants } from '../constants/actionTypes'
import * as emailService from '../services/email/emailService'
import { alertError } from './alertActions'
import { fetchUserSuccess } from './userActions'

export const fetchIndividualEstimateRequest = () => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_REQUEST,
})

export const fetchIndividualEstimateSuccess = (
  estimate,
  estimateId,
  isGov,
  afterMarketAccessories,
  isProposal,
  proposalNumber,
  dateOfProposalAcceptance
) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_SUCCESS,
  estimate,
  estimateId,
  isGov,
  afterMarketAccessories,
  isProposal,
  proposalNumber,
  dateOfProposalAcceptance,
})

export const fetchIndividualEstimateError = (errorMessage) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_ERROR,
  errorMessage,
})

export function fetchIndividualEstimate(
  opportunityId,
  estimateId,
  isConsultant,
  accessToken
) {
  return (dispatch) => {
    dispatch(fetchIndividualEstimateRequest())
    return emailService
      .fetchIndividualEstimate(
        opportunityId,
        estimateId,
        isConsultant,
        accessToken
      )
      .then(
        (res) => {
          dispatch(
            fetchIndividualEstimateSuccess(
              res.quote,
              estimateId,
              res.parentOrganisationERCode,
              res.afterMarketAccessories,
              res.isProposal,
              res.proposalNumber,
              res.dateOfProposalAcceptance
            )
          )

          dispatch(
            fetchUserSuccess({
              customer: res.customer,
              parentOrganisationERCode: res.parentOrganisationERCode,
            })
          )
        },
        (error) => {
          dispatch(fetchIndividualEstimateError(error, estimateId))
          dispatch(alertError(error))
        }
      )
  }
}
